var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.800049 2.7999C0.800049 1.47442 1.87457 0.399902 3.20005 0.399902H8.70299C9.33951 0.399902 9.94996 0.652759 10.4 1.10285L14.4971 5.1999C14.9472 5.64999 15.2 6.26044 15.2 6.89696V17.1999C15.2 18.5254 14.1255 19.5999 12.8 19.5999H3.20005C1.87456 19.5999 0.800049 18.5254 0.800049 17.1999V2.7999ZM3.20005 9.9999C3.20005 9.33716 3.73731 8.7999 4.40005 8.7999H11.6C12.2628 8.7999 12.8 9.33716 12.8 9.9999C12.8 10.6626 12.2628 11.1999 11.6 11.1999H4.40005C3.73731 11.1999 3.20005 10.6626 3.20005 9.9999ZM4.40005 13.5999C3.73731 13.5999 3.20005 14.1372 3.20005 14.7999C3.20005 15.4626 3.73731 15.9999 4.40005 15.9999H11.6C12.2628 15.9999 12.8 15.4626 12.8 14.7999C12.8 14.1372 12.2628 13.5999 11.6 13.5999H4.40005Z",
    fill: "#6B7280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.d148fa7dcb4a39813e2f65c785cfee65.svg";
export { ForwardRef as ReactComponent };